module.exports = __webpack_public_path__ + "static/media/main-characters.96a25573.png";